import React from 'react'
import Star from 'Elements/Star'
import Button from 'Elements/Button'
import Slie from 'react-reveal/Slide'

export default function Testimony({data}) {
  return (
    <Slie bottom>
    <section className="container">
        <div className="row align-items-center">
            <div className="col-auto" style={{ marginRight: 60 }}>
                    <div
                        className="testimonial-hero"
                        style={{ margin: `30px 0 0 30px` }}
                        >
                        <img
                            src={data.imageUrl}
                            alt="Testimonial"
                            className="position-absolute"
                            style={{ zIndex: 1 }}
                        />
                    
                    </div>
            </div>
            <div className="col">
                <h4 style={{ marginBottom: 40 }}>{data.name}</h4>
                <Star value={data.rate} width={45} height={45} spacing={4} />
                <h5 className="h2 font-weight-light line-height-2 my-3">
                {data.content}
                </h5>
                <span className="text-gray-500">
                {data.familyName}, {data.familyOccupation}
                </span>

            <div>
                <Button
                    className="btn px-5 text-white"
                    style={{ marginTop: 40 }}
                    hasShadow
                    isPrimary
                    type="link"
                    href={`/testimonial/${data._id}`}
                >
                    Read Their Story
                </Button>
            </div>
          </div>
        </div>
      </section>
      </Slie>
  )
}
